const solicitationTypes = {
    TYPE_UPDATE_AMPLITUDE_PARAMETER_PK: 1, //Alteração de Parâmetro de Amplitude
    TYPE_UPDATE_ASSORTMENT_PARAMETER_PK: 2, //Alteração de Parâmetro do Sortimento
    TYPE_REQUEST_EXTRA_PRODUCT_PK: 3, //Produto Extra
    TYPE_REMOVE_PRODUCT_PK: 4, //Remoção de Produto no Sortimento
    TYPE_ADD_PRODUCT_SYSTEM_PK: 5, //Back only - Adição de Produto no Sortimento pelo Sistema
    TYPE_ADD_PRODUCT_MANAGER_PK: 6, //Adição de Produto no Sortimento pelo Gerente
    TYPE_FAVORITE_PRODUCT_PK: 7, //Favoritar Produto
    TYPE_REMOVE_FAVORITE_PRODUCT_PK: 8 //Desfavoritar Produto
}

const status = {
    APPROVED: 'A',
    REPROVED: 'R',
    IN_ANALYSIS: 'N',
    PENDING: 'P',
    CONCLUDED: 'C'
}

const parameterActions = {
    ACTION_SIMULATION_PK: 1,
    ACTION_DAILY_SIMULATION_PK: 2,
    ACTION_RANKING_PK: 3,
    ACTION_RESTOCKING_PK: 4
}

export { solicitationTypes, status, parameterActions }
